module.exports = __webpack_public_path__ + "static/media/card-logo-mastercard.3678c9c0.svg";